export const BENEFIT_MESSAGE = {
  JOIN_NEW: '신규 가입 혜택을 확인해 보세요',
  BIRTHDAY: '고객님을 위한 생일 쿠폰을 준비했어요',
  NEW_BENEFIT: '새로운 혜택을 확인해 보세요',
  MONTHLY: (month) => `${month} 멤버십 혜택을 확인해 보세요`,
  BRAND: (count) => `${count}개 브랜드 할인 쿠폰이 있어요`,
  BRAND_DETAIL: '보고 계신 브랜드에 쿠폰이 있어요',
  CATEGORY: '보고 계신 카테고리에 쿠폰이 있어요',
};
